module.exports = __webpack_public_path__ + "static/img/1.101238b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/1.png
// module id = PvNL
// module chunks = 0